import { Client } from '@viddsee/server-api-client';
import { baseConfiguration } from './webcall-base';

export const infoApi = new Client.InfoApi(baseConfiguration);
